import data from "../../../../../src/Hidden/Hidden.docs.json";
import * as React from 'react';
export default {
  data,
  React
};